import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../app/i18n";
import { StatusPage } from "../areas/public/status/StatusPage";

export const Route = createFileRoute("/status")({
  beforeLoad: () => loadNamespaces("public"),
  component: StatusPage,
});
